import { PrizeDistributionItem } from './detail/prize-pool/prize-pool.component';

/** Normalize API/UI prize_type values (e.g. "NO CASH", "no_cash") to NO_CASH, CASH, etc. */
export function normalizePrizeType(prizeType: string | undefined | null): string {
  if (prizeType == null) {
    return '';
  }
  return String(prizeType).toUpperCase().trim().replace(/\s+/g, '_');
}

export function isNoCashPrizeType(prizeType: string | undefined | null): boolean {
  return normalizePrizeType(prizeType) === 'NO_CASH';
}

export function getZeroPrizeDistribution(): PrizeDistributionItem[] {
  return [
    { position: '1st', amount: 0 },
    { position: '2nd', amount: 0 },
    { position: '3rd', amount: 0 },
  ];
}
